import { ADD_ERROR, MARK_READED_ERROR, ADD_AUTH_ERROR } from './actionType';

export const addError = error => ({
  type: ADD_ERROR,
  error,
});
export const markReadedError = id => ({
  type: MARK_READED_ERROR,
  id,
});

export const addAuthError = error => ({
  type: ADD_AUTH_ERROR,
  error,
});



// WEBPACK FOOTER //
// ./src/store/error/action.js